import {REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP,
};
